export function setViewHeight() {
  if (typeof window !== `undefined`) {
    let vh = window.innerHeight * 0.01
    let vhNav = vh - 0.6
    document.documentElement.style.setProperty("--vh", `${vhNav}px`)
  }
}
